import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils/request'

const initialState = {}

export const submitFeedback = createAsyncThunk<any, any>(
  'submitFeedback',
  async (arg) => {
    return req({
      url: '/api/feedback/submit',
      params: {...arg},
    })
  }
)
// 免登录
export const websiteFeedback = createAsyncThunk<any, any>(
  'websiteFeedback',
  async (arg) => {
    return req({
      url: '/api/feedback/website_feedback',
      params: {...arg},
    })
  }
)

export const submitFeedbackReport = createAsyncThunk<any, any>(
  'submitFeedbackReport',
  async (arg) => {
    return req({
      url: '/api/feedback/submit_report',
      params: {...arg},
    })
  }
)

export const submitReviewReport = createAsyncThunk<any, any>(
  'submitReviewReport',
  async (arg) => {
    return req({
      url: '/api/review/report',
      params: {...arg},
    })
  }
)

export const feedBackSlice = createSlice({
  name: 'feedBack',
  initialState,
  reducers: {},
  extraReducers: () => {},
})

export default feedBackSlice.reducer
